import { rerender as reRender } from 'inferno';
import { InfernoEffect } from './effect';
export var createReRenderEffect = function createReRenderEffect() {
  return new InfernoEffect(function () {
    reRender();
  }, []);
};